import React from 'react';
import './App.css';
import Page from './components/page';
import RepoFetch from './components/repofetch';
function App() {

  

  return (
    <div className="App">
      <Page />
      <RepoFetch />
    </div>
  );
}

export default App;
